<style lang="less">
  .brower{
    position: absolute;
    top: 40%;
    font-size: 20px;
    width: 100%;
    text-align: center;
    padding: 0 30px;
  }
</style>
<template>
  <div class="app" id="app">
    <div v-if="browerWin" class="brower">
      {{$t('pubcourse.tip.browserWin')}}
    </div>
    <component v-else :is="pageName" @routerTo="routerTo" :pageData="pageData"></component>
  </div>
</template>

<script>
  import pubcoursePage from '@/components/pubcourse/page';
  import tippage       from '@/components/pubcourse/tippage.vue';
  export default {
    components:{
      pubcoursePage,
      tippage
    },
    filters:{
    },
    data(){
      return {
        pageName:'',
        pageData:'',
        browerWin:false,
      }
    },
    methods:{
      routerTo(actionName,pageData, message){
        this.pageName='';
        switch(actionName){
          case 'pubcoursePage':
            this.pageName = 'pubcoursePage';
            break;
          case 'jumppage':
            this.pageName = 'jumppage';
            break;
          case 'tippage':
            this.pageName = 'tippage';
            this.pageData = pageData;
            break;
        }
      }
    },
    mounted(){
      this.routerTo('pubcoursePage');
      this.browerWin = (!window.browserVersion.mobile)&&window.browserVersion.weixin;
    }
  }
</script>